import clsx from 'clsx';
import React, { VFC } from 'react';
import { DropdownItemType } from 'types/common';

import styles from './MultiDropdownItem.module.scss';

interface ItemProps {
  item: DropdownItemType;
  onSelect?: (item: DropdownItemType) => void;
  active: boolean;
}

const Item: VFC<ItemProps> = ({ item, onSelect, active }) => {
  return (
    <button
      className={clsx({
        [styles['DropdownItem--active']]: active
      })}
      type="button"
      onClick={() => onSelect(item)}
    >
      {item.label ? <span>{item.label}</span> : item.name}
    </button>
  );
};

export default Item;
